var YouLi = YouLi ? YouLi : {};
YouLi.CreditCardPaymentForm = YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {};

(function (YouLi) {
    (function (CreditCardPaymentForm) {

        ///
        /// Developer Note: the intention of this script is to provide all the code for making credit card payments, for ALL the different providers.
        /// As of right now, it has only had the Stripe, Square and Cybersource code migrated across to it. The next step must be to move Authorize.NET across, out of the youli.trip.payments.js file.
        ///

        YouLi.CreditCardPaymentForm.ConnectedPaymentGateway = YouLi.Common.PaymentGateway.CyberSource;
        YouLi.CreditCardPaymentForm.ConnectedPaymentGatewayUserId = "";

        YouLi.CreditCardPaymentForm.Currency = "";
        YouLi.CreditCardPaymentForm.CountryCode = "";
        YouLi.CreditCardPaymentForm.Name = "";
        YouLi.CreditCardPaymentForm.TransactionFee = 0;
        YouLi.CreditCardPaymentForm.InviteeReferenceCode = "";
        YouLi.CreditCardPaymentForm.IsRegisteredWithPayment = false;

        YouLi.CreditCardPaymentForm.CancelPaymentCallback = undefined;
        YouLi.CreditCardPaymentForm.ProcessStripePaymentFunction = undefined;
        YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction = undefined;
        YouLi.CreditCardPaymentForm.DoOverpaymentCheck = true;  // Future improvement: we could add a "prepayment" hook instead, which may do the check for overpayment or anything else which is page-specific
        YouLi.CreditCardPaymentForm.MakePaymentFunction = undefined;

        YouLi.CreditCardPaymentForm.CybersourceCountryStates = undefined;
        YouLi.CreditCardPaymentForm.AuthorizeCountryStates = undefined;
        YouLi.CreditCardPaymentForm.InitialState = undefined;

        YouLi.CreditCardPaymentForm.CyberSourceJWT = undefined;
        YouLi.CreditCardPaymentForm.CyberSourceForm = null;

        YouLi.CreditCardPaymentForm.AuthorizeNetClientKey = "";
        YouLi.CreditCardPaymentForm.AuthorizeNetAPIKey = "";

        YouLi.CreditCardPaymentForm.StripeHandler = undefined;
        YouLi.CreditCardPaymentForm.StripeKey = undefined;
        YouLi.CreditCardPaymentForm.StripeElements = undefined;
        YouLi.CreditCardPaymentForm.StripePaymentElement = undefined;
        YouLi.CreditCardPaymentForm.StripePaymentIntentId = undefined;
        YouLi.CreditCardPaymentForm.StripeRedirectURL = window.location.href;
        YouLi.CreditCardPaymentForm.IsFutureUsageAllowed = false;
        YouLi.CreditCardPaymentForm.SelectedPaymentMethodType = null;

        YouLi.CreditCardPaymentForm.SquareApplicationId = '';
        YouLi.CreditCardPaymentForm.SquareLocationId = '';
        YouLi.CreditCardPaymentForm.SquarePaymentCardObject = null;

        //YouLi.CreditCardPaymentForm.PayPalCardFields = null;
        YouLi.CreditCardPaymentForm.PayPalButtons = null;

        YouLi.CreditCardPaymentForm.ShowAutoPay = false;
        YouLi.CreditCardPaymentForm.TripHasInstallmentsWithoutDueDate = false;
        YouLi.CreditCardPaymentForm.StripeIntegrationType = undefined;
        YouLi.CreditCardPaymentForm.IsAllowCheckoutSession = false;
        YouLi.CreditCardPaymentForm.IsAllowSaveCard = false;

        YouLi.CreditCardPaymentForm.HandleFormSubmit = function (event) {
            event.preventDefault();

            switch (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway) {
                case YouLi.Common.PaymentGateway.Stripe:
                    YouLi.CreditCardPaymentForm.StripePay.CompleteStripePayment();
                    break;
                case YouLi.Common.PaymentGateway.CyberSource:
                    YouLi.CreditCardPaymentForm.CyberSource.CyberSourceRequestCardNonce();
                    break;
                case YouLi.Common.PaymentGateway.Square:
                    YouLi.CreditCardPaymentForm.Square.SquareHandlePaymentMethodSubmission();
                    break;
                case YouLi.Common.PaymentGateway.AuthorizeNet:
                    YouLi.CreditCardPaymentForm.AuthorizeNet.SendPaymentDataToAuthorizeNet();
                    break;
            }
        };

        YouLi.CreditCardPaymentForm.CancelInProgressPayment = function (paymentIdsToDelete) {

            if (YouLi.CreditCardPaymentForm.CancelPaymentCallback)
                return YouLi.CreditCardPaymentForm.CancelPaymentCallback(paymentIdsToDelete);

            if (!paymentIdsToDelete || paymentIdsToDelete.length == 0)
                return Promise.resolve();

            const data = {
                tripId: $("#TripId").val(),
                inviteeId: $("#InviteeId").val(),
                paymentIdsToDelete: paymentIdsToDelete
            }

            return YouLi.Common.Post({
                url: '/trip/cancelinprogresspayment',
                params: data
            });

        }

        YouLi.CreditCardPaymentForm.CheckForOverpayment = function () {

            if (!YouLi.CreditCardPaymentForm.DoOverpaymentCheck)
                return Promise.resolve();

            let data = {
                couponCode: $("#ChargeCouponCode").val(),
                tripId: $("#TripId").val(),
                inviteeId: $("#InviteeId").val(),
                chargeAmount: $("#ChargeAmount").val(),
                surchargeAmount: $("#SurchargeAmount").val(),
                refundProtectAmount: $("#RefundProtectAmount").val(),
                originPage: $("#OriginPage").val()
            };

            return new Promise(function (resolve, reject) {
                YouLi.Common.Post({
                    url: '/trip/checkpaymentforoverpayment',
                    params: data,
                    suppressLoading: true,
                    errorCallback: function () {
                        YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction("", moment());

                        reject({
                            message: "Failed on check for overpayment",
                            errorHandled: true
                        });
                    }
                }).then(function (response) {
                    if (response.url) {
                        window.location.href = response.url;
                    }
                    else if (response.errorMessage) {
                        YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction(response.errorMessage, moment(response.paymentErrorDate));

                        reject({
                            message: "Failed on check for overpayment",
                            errorHandled: true
                        });
                    }
                    else {
                        resolve();
                    }
                });
            });

        };

        YouLi.CreditCardPaymentForm.ClearErrorInModal = function () {
            $("#GenericPaymentErrorMessage").addClass("hidden");
        }

        YouLi.CreditCardPaymentForm.ShowErrorInModal = function (message, reason, paymentMethod) {
            var errorMessage = message + (reason ? ` [${reason}]` : "");

            if (paymentMethod === 'paypal') {
                const $error = $('<strong>Failed Processing Payment by card issuer.</strong><br/>\n' +
                    '<strong>Contact your credit card company for approval and try again.</strong><br/>\n' +
                    '<span id="PaymentErrorMessage" class="payment-error-message"></span>');

                $("#GenericPaymentErrorMessage")
                    .html($error)
                    .removeClass("hidden")
                    .find('.payment-error-message')
                    .text(reason);
            } else {
                $("#GenericPaymentErrorMessage").text(errorMessage).removeClass("hidden");
            }

            // To do: it would be good to scroll to an element within the FORM not the container
            // (or else get that parent container ID passed in and use that)
            YouLi.Common.UI.ScrollToTopModal("GenericPaymentFormDialog");
        }

        YouLi.CreditCardPaymentForm.RefreshValidators = function () {
            $("#GenericPaymentForm").validateBootstrap(true);
        }

        YouLi.CreditCardPaymentForm.UpdateStateSelections = function () {
            if ($("#p-billto-country").val()) {

                var selectedCountryStates = undefined;
                // TODO: Add in AuthoriseNet when we move that code to here
                switch (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway) {
                    case YouLi.Common.PaymentGateway.CyberSource:
                        selectedCountryStates = YouLi.CreditCardPaymentForm.CybersourceCountryStates.find(i => i.Country.Label == $("#p-billto-country").val());
                        break;
                    case YouLi.Common.PaymentGateway.AuthorizeNet:
                        selectedCountryStates = YouLi.CreditCardPaymentForm.AuthorizeCountryStates.find(i => i.Country.Label == $("#p-billto-country").val());
                        break;
                }

                if (selectedCountryStates && selectedCountryStates.States.length > 0) {

                    var arrOptions = [];
                    arrOptions.push("<option value='' selected>Select a state</option>");

                    for (i = 0; i < selectedCountryStates.States.length; i++) {
                        arrOptions.push(`<option value='${selectedCountryStates.States[i].Label}'>${selectedCountryStates.States[i].Label}</option>`);
                    }

                    $("#StateSelection").html(getBillToStateDropdown());
                    $("#p-billto-state").html(arrOptions.join(""));
                } else {
                    // no states defiend for selected country, so show a plain text input for state
                    $("#StateSelection").html(getBillToStateTextInput());
                }
            } else {
                // no country selected, so show a plain text input for state
                $("#StateSelection").html(getBillToStateTextInput());
            }

            YouLi.CreditCardPaymentForm.RefreshValidators();
        }

        YouLi.CreditCardPaymentForm.UpdateAutoPayVisibility = function (showAutoPay) {
            YouLi.CreditCardPaymentForm.ShowAutoPay = showAutoPay;

            if ($("#AutoPayEnrolOption", "#GenericPaymentFormDialog").length > 0 && !YouLi.CreditCardPaymentForm.TripHasInstallmentsWithoutDueDate) {
                $("#AutoPayEnrolOption", "#GenericPaymentFormDialog").toggleClass("hidden", !showAutoPay);

                if (!showAutoPay)
                    $("#EnrolInAutoPay", "#GenericPaymentFormDialog").attr("disabled", true);
            }
        };

        function getBillToStateTextInput() {
            return '<input type="text" class="form-control card-field" id="p-billto-state" name="billtostate" placeholder="State" data-val="true" data-val-required="State is required" />'
        }

        function getBillToStateDropdown() {
            return '<select class="form-control card-field" id="p-billto-state" name="billtostate" data-val="true" data-val-required="State is required"></select>';
        }

        $(function () {

            $("#GenericPaymentFormDialog").off("show.bs.modal");
            $("#GenericPaymentFormDialog").on("show.bs.modal", function () {
                if (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.Square) {
                    YouLi.CreditCardPaymentForm.Square.InitialiseSquare();
                } else if (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.CyberSource) {
                    YouLi.CreditCardPaymentForm.CyberSource.InitialiseCyberSource();
                } else if (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.PayPal) {
                    YouLi.CreditCardPaymentForm.Paypal.InitialisePayPal();
                }

                $(".content-trip-paymentdetails-error").addClass("hidden");
            });

            $("#GenericPaymentFormDialog").off("hide.bs.modal");
            $("#GenericPaymentFormDialog").on("hide.bs.modal", function () {

                if (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.Stripe && YouLi.CreditCardPaymentForm.StripePaymentElement) {
                    // Fully destroy the Stripe payment element when the dialog is closed.  Changes to amounts require a new element to be
                    // created, as the amount for the payment can change things like the available payment methods
                    YouLi.CreditCardPaymentForm.StripePaymentElement.destroy();
                    YouLi.CreditCardPaymentForm.StripeElements = undefined;
                    YouLi.CreditCardPaymentForm.StripePaymentElement = undefined;
                } else if (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.CyberSource) {
                    if (YouLi.CreditCardPaymentForm.CyberSourceForm)
                        YouLi.CreditCardPaymentForm.CyberSourceForm.teardown();
                } else if (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.Square) {
                    if (YouLi.CreditCardPaymentForm.SquarePaymentCardObject)
                        YouLi.CreditCardPaymentForm.SquarePaymentCardObject.destroy();
                } else if (YouLi.CreditCardPaymentForm.ConnectedPaymentGateway === YouLi.Common.PaymentGateway.AuthorizeNet) {
                    YouLi.CreditCardPaymentForm.AuthorizeNet.ClearAuthorizeNetForm();
                }

                YouLi.CreditCardPaymentForm.ClearErrorInModal();
            });

            $("#p-billto-country").off("change");
            $("#p-billto-country").on("change", function () {
                YouLi.CreditCardPaymentForm.UpdateStateSelections();
            })
            YouLi.CreditCardPaymentForm.UpdateStateSelections();

            // initialise the state selection/value
            $("#p-billto-state").val(YouLi.CreditCardPaymentForm.InitialState);
        });

    }(YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {}));
}(YouLi ? YouLi : {}));